import { createContext, useState } from "react";
import PropTypes from "prop-types";

const ADMIN_AUTH_STORAGE_KEY = "admin-login-user";

const getStoredAdminUser = () => {
  try {
    const storedAdminUser = localStorage.getItem(ADMIN_AUTH_STORAGE_KEY);
    return storedAdminUser ? JSON.parse(storedAdminUser) : null;
  } catch {
    localStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
    return null;
  }
};

const AdminAuthContext = createContext();

export const AdminAuthProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(getStoredAdminUser);

  const loginAdmin = (token, userInfo, dashboard) => {
    const userData = {
      token,
      role: "Admin",
      userInfo,
      dashboard,
    };

    localStorage.setItem(ADMIN_AUTH_STORAGE_KEY, JSON.stringify(userData));
    setAdminUser(userData);
  };

  const logoutAdmin = () => {
    localStorage.removeItem(ADMIN_AUTH_STORAGE_KEY);
    setAdminUser(null);
  };

  return (
    <AdminAuthContext.Provider
      value={{
        adminUser,
        loginAdmin,
        logoutAdmin,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
};

AdminAuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AdminAuthContext;
